module.exports = __webpack_public_path__ + "static/fonts/menu-logo-tv.svg";